/**
 * PublishButton -- Shows publish status and triggers site publishing.
 *
 * - When is_dirty=false: disabled button with "Published" text + last published date
 * - When is_dirty=true: enabled primary button with "Publish" text
 * - Loading state during publish operation
 */
import { Button } from '../ui/Button';

export interface PublishButtonProps {
  isDirty: boolean;
  isPublishing: boolean;
  lastPublishedAt: string | null;
  onPublish: () => void;
}

function formatPublishDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

export function PublishButton({
  isDirty,
  isPublishing,
  lastPublishedAt,
  onPublish,
}: PublishButtonProps) {
  return (
    <div className="publish-button">
      {lastPublishedAt && !isDirty && (
        <span className="publish-button__status">
          Published {formatPublishDate(lastPublishedAt)}
        </span>
      )}
      {isDirty && !isPublishing && (
        <span className="publish-button__status publish-button__status--dirty">
          Unpublished changes
        </span>
      )}
      <Button
        variant="primary"
        size="md"
        disabled={!isDirty || isPublishing}
        loading={isPublishing}
        onClick={onPublish}
      >
        {isPublishing ? 'Publishing...' : isDirty ? 'Publish' : 'Published'}
      </Button>
    </div>
  );
}
